import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  pageTitle: {
    id: 'portal.components.courseUnavailable.pageTitle',
    defaultMessage: 'Course unavailable',
    description: 'Title shown when the requested course is not available to the user',
  },
  mainMessage: {
    id: 'portal.components.courseUnavailable.message',
    defaultMessage: 'This course is not available in your language or could not be found.',
    description: 'Main message for the "course unavailable" page',
  },
  additionalInfo: {
    id: 'portal.components.courseUnavailable.additionalInfo',
    defaultMessage: 'Browse our catalogue to see the courses that are available to you.',
    description: 'Secondary message for the "course unavailable" page',
  },
  browseCatalogue: {
    id: 'portal.components.courseUnavailable.action.browseCatalogue',
    defaultMessage: 'Browse Catalogue',
    description: 'CTA to navigate to the course catalogue',
  },
  returnHome: {
    id: 'portal.components.courseUnavailable.action.returnHome',
    defaultMessage: 'Return to Home',
    description: 'CTA to navigate back to the home page',
  },
});

export default messages;
